/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Form_LabelInputs */

const en_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File import form`)
};

const fr_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File import form`)
};

const de_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiimportformular`)
};

const it_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di importazione file`)
};

const ru_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма импорта файла`)
};

const es_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de importación de archivos`)
};

const zh_cn2_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件导入表单`)
};

const ja_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルインポートフォーム`)
};

const hi_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल आयात फ़ॉर्म`)
};

const pt_pt2_file_import_form_label = /** @type {(inputs: File_Import_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de importação de arquivos`)
};

/**
* | output |
* | --- |
* | "File import form" |
*
* @param {File_Import_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_form_label = /** @type {((inputs?: File_Import_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_form_label(inputs)
	if (locale === "de") return de_file_import_form_label(inputs)
	if (locale === "it") return it_file_import_form_label(inputs)
	if (locale === "ru") return ru_file_import_form_label(inputs)
	if (locale === "es") return es_file_import_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_form_label(inputs)
	if (locale === "ja") return ja_file_import_form_label(inputs)
	if (locale === "hi") return hi_file_import_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_form_label(inputs)
	return en_file_import_form_label(inputs)
});